import {IService, ISoundPlayer, SystemComponentType} from '@gongxigames/framework/core/types';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {inject, injectable} from '@gongxigames/framework/core/installer';
import {coreStore} from '@gongxigames/framework/core/globals';
import {ResourceLoader} from '@gongxigames/framework/core/services/resourceLoader/ResourceLoader';
import {UpdateManager} from '@gongxigames/framework/core/services/UpdateManager';
import {LanguageService} from '@gongxigames/framework/core/services/LanguageService';
import {CurrencyFormatter} from '@gongxigames/framework/core/services/CurrencyFormatter';
import {SpineUtils} from '@gongxigames/framework/core/services/SpineUtils';
import {System} from '@gongxigames/framework/core/services/system/System';
import {SoundManager} from '@gongxigames/framework/slot/services/SoundManager';

@injectable()
export class StoreSetter implements IService {
    public static NAME = Symbol('StoreSetter');
    public type: SystemComponentType = 'service';

    @inject(CoreDI.ResourceLoader)
    private readonly _resourceLoader!: ResourceLoader;

    @inject(CoreDI.UpdateManager)
    private readonly _updateManager!: UpdateManager;

    @inject(CoreDI.LanguageService)
    private _languageService!: LanguageService;

    @inject(CoreDI.CurrencyFormatter)
    private _currencyFormatter!: CurrencyFormatter;

    @inject(CoreDI.SpineUtils)
    protected _spineUtils!: SpineUtils;

    @inject(CoreDI.System)
    protected _system!: System;

    @inject(CoreDI.SoundPlayer)
    protected _soundPlayer!: ISoundPlayer;

    @inject(CoreDI.SoundManager)
    private _soundManager!: SoundManager;

    public init(): void {
        coreStore.batchUpdate({
            resourceLoader: this._resourceLoader,
            updateManager: this._updateManager,
            languageService: this._languageService,
            currencyFormatter: this._currencyFormatter,
            spineUtils: this._spineUtils,
            renderer: this._system.app.renderer,
            soundPlayer: this._soundPlayer,
            soundManager: this._soundManager,
        });
    }
}
